import React, { useState } from 'react';
import '../../css/Login.css';
import logo from '../../assets/logo.png';
import { Link, useNavigate } from 'react-router-dom';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../../firebase';

function Login() {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false); // <-- New state for spinner

    const handleLogin = async (e) => {
        e.preventDefault();
        setError('');
        setIsLoading(true); // Show loader

        try {
            await signInWithEmailAndPassword(auth, email, password);
            navigate('/'); // Navigate to home/dashboard
        } catch (err) {
            setError('Invalid email or password');
            console.error(err.message);
        } finally {
            setIsLoading(false); // Hide loader
        }
    };

    return (
        <div className="login-container">
            <div className="login-box">
                <img src={logo} alt="Logo" className="login-logo" />
                <h2 className="login-title">Login</h2>
                <p className="login-subtitle">Please login to your account</p>

                <form className="login-form" onSubmit={handleLogin}>
                    <input
                        type="email"
                        placeholder="Email"
                        className="login-input"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        disabled={isLoading}
                    />
                    <input
                        type="password"
                        placeholder="Password"
                        className="login-input"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        disabled={isLoading}
                    />

                    <p className='p' style={{ textAlign: 'right', marginBottom: '15px' }}>
                        <Link to="/forgot-password" className="login-link">Forgot Password?</Link>
                    </p>

                    {error && <p className="error-message">{error}</p>}

                    <button type="submit" className="login-button" disabled={isLoading}>
                        {isLoading ? <div className="spinner"></div> : 'Login'}
                    </button>
                </form>

                <div className="login-footer">
                    <p>
                        Don't have an account?{' '}
                        <Link to="/register" className="login-link">Register</Link>
                    </p>
                </div>
            </div>
        </div>
    );
}

export default Login;
